import { monitoringConstants } from "../_constants";
import { APIcallFunction, headerForPrivateAPI } from "../_helpers";
import { alertActions } from "./alert.actions";

export const monitoringUnitsAction = {
  ipAddressMonitoringList,
  getCountryCodeList,
  ipAddressWhiteAndBlackListing,
  viewIpAddressHistoryByPromise,
  convertIpAddressInWhiteOrBlackListByPromise,
  transactionMonitoring,
  feesMonitoringList,
  webStoresMonitoring,
  userCreditScoreMonitoring,
  viewUserCreditScoreHistoryByPromise
};

function ipAddressMonitoringList(data, details) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/monitoring/ipAddressMonitoring",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: monitoringConstants.GET_IP_ADDRESS_MONITORING_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: monitoringConstants.GET_IP_ADDRESS_MONITORING_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: monitoringConstants.GET_IP_ADDRESS_MONITORING_LIST_FAILURE,
      error,
    };
  }
}

function getCountryCodeList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/user/getAllCountryCodeListApi",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: monitoringConstants.GET_COUNTRY_CODE_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: monitoringConstants.GET_COUNTRY_CODE_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: monitoringConstants.GET_COUNTRY_CODE_LIST_FAILURE,
      error,
    };
  }
}

function ipAddressWhiteAndBlackListing(data, details) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/monitoring/ipAddressWhiteAndBlackListing",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: monitoringConstants.GET_IP_ADDRESS_WHITE_AND_BLACK_LISTING_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: monitoringConstants.GET_IP_ADDRESS_WHITE_AND_BLACK_LISTING_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: monitoringConstants.GET_IP_ADDRESS_WHITE_AND_BLACK_LISTING_FAILURE,
      error,
    };
  }
}

function viewIpAddressHistoryByPromise(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/monitoring/viewIpAddressHistory",
  };
  return APIcallFunction(credentials);
}

function convertIpAddressInWhiteOrBlackListByPromise(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/monitoring/convertIpAddressInWhiteOrBlackList",
  };
  return APIcallFunction(credentials);
}

function transactionMonitoring(data, details) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/monitoring/transactionMonitoring",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: monitoringConstants.GET_TRANSACTION_MONITORING_FAILURE,
      user,
    };
  }
  function success(user) {
    return {
      type: monitoringConstants.GET_TRANSACTION_MONITORING_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: monitoringConstants.GET_TRANSACTION_MONITORING_FAILURE,
      error,
    };
  }
}

function feesMonitoringList(data, details) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/monitoring/feesMonitoringList",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: monitoringConstants.GET_FEES_MONITORING_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: monitoringConstants.GET_FEES_MONITORING_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: monitoringConstants.GET_FEES_MONITORING_LIST_FAILURE,
      error,
    };
  }
}

function webStoresMonitoring(data, details) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/monitoring/webStoresMonitoring",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: monitoringConstants.GET_WEB_STORES_MONITORING_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: monitoringConstants.GET_WEB_STORES_MONITORING_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: monitoringConstants.GET_WEB_STORES_MONITORING_LIST_FAILURE,
      error,
    };
  }
}

function userCreditScoreMonitoring(data, details) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/monitoring/userCreditScoreMonitoring",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: monitoringConstants.GET_USER_CREDIT_SCORE_MONITORING_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: monitoringConstants.GET_USER_CREDIT_SCORE_MONITORING_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: monitoringConstants.GET_USER_CREDIT_SCORE_MONITORING_LIST_FAILURE,
      error,
    };
  }
}

function viewUserCreditScoreHistoryByPromise(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/monitoring/viewUserCreditScoreHistory",
  };
  return APIcallFunction(credentials);
}